// src/pages/Media.jsx
import React, { useState } from 'react'
import Hero from '../components/Hero'
import Card2D from '../components/Card2D'
import Carousel from '../components/Carousel'

const Media = () => {
  const [activeTab, setActiveTab] = useState('all')

    const Hero = ({ title, subtitle, images, backgroundImage, showButtons = true }) => (
  <div className="relative h-screen z-10 overflow-hidden">
    {/* Background Image */}
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage || images[0]})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

    {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="max-w-2xl mx-auto">
              <h1 className="font-libre text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6">
                {title}
              </h1>
              <p className="font-inter text-lg text-gray-200">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
  </div>
    )

  const pressReleases = [
    {
      id: 1,
      title: 'OFANDA Africa Wins 2024 Real Estate Excellence Award',
      source: 'African Business Times',
      date: '2024-01-15',
      category: 'award',
      excerpt: 'Recognized for innovative valuation methodologies and market leadership across West Africa.',
      image: '/api/placeholder/400/250',
      readTime: '3 min read'
    },
    {
      id: 2,
      title: 'New RICS-Compliant Valuation Framework Launched',
      source: 'Property Journal Africa',
      date: '2024-01-10',
      category: 'innovation',
      excerpt: 'Introducing advanced valuation standards combining international best practices with local market insights.',
      image: '/api/placeholder/400/250',
      readTime: '4 min read'
    },
    {
      id: 3,
      title: 'OFANDA Expands to East African Market',
      source: 'Business Daily Africa',
      date: '2024-01-05',
      category: 'expansion',
      excerpt: 'Strategic expansion into Kenya and Tanzania to serve growing real estate markets.',
      image: '/api/placeholder/400/250',
      readTime: '5 min read'
    },
    {
      id: 4,
      title: 'Partnership Announced with Global Property Tech Firm',
      source: 'Tech in Real Estate',
      date: '2023-12-20',
      category: 'partnership',
      excerpt: 'Collaboration to integrate AI and machine learning in property valuation processes.',
      image: '/api/placeholder/400/250',
      readTime: '4 min read'
    }
  ]

  const blogPosts = [
    {
      id: 1,
      title: 'The Future of Commercial Real Estate in West Africa',
      author: 'Kwesi Andoh',
      role: 'Principal Valuer',
      date: '2024-01-12',
      excerpt: 'Exploring emerging trends in commercial property markets and investment opportunities in the region.',
      image: '/api/placeholder/400/250',
      readTime: '6 min read',
      tags: ['Commercial', 'Trends', 'Investment']
    },
    {
      id: 2,
      title: 'Understanding RICS Valuation Standards in African Context',
      author: 'Akua Mensah',
      role: 'Senior Consultant',
      date: '2024-01-08',
      excerpt: 'How international valuation standards apply to unique African property markets and local practices.',
      image: '/api/placeholder/400/250',
      readTime: '8 min read',
      tags: ['RICS', 'Standards', 'Valuation']
    },
    {
      id: 3,
      title: 'Data-Driven Approaches to Property Valuation',
      author: 'Yaw Boateng',
      role: 'Data Analyst',
      date: '2024-01-03',
      excerpt: 'Leveraging big data and analytics for more accurate and efficient property assessments.',
      image: '/api/placeholder/400/250',
      readTime: '7 min read',
      tags: ['Data', 'Analytics', 'Technology']
    },
    {
      id: 4,
      title: 'Sustainable Development in African Real Estate',
      author: 'Nana Ama',
      role: 'Sustainability Lead',
      date: '2023-12-28',
      excerpt: 'Incorporating environmental considerations and sustainable practices in property development.',
      image: '/api/placeholder/400/250',
      readTime: '5 min read',
      tags: ['Sustainability', 'Development', 'Green']
    }
  ]

  const videos = [
    {
      id: 1,
      title: 'OFANDA Africa Company Overview',
      description: 'Learn about our services, expertise, and vision for African real estate.',
      duration: '2:45',
      thumbnail: '/api/placeholder/400/225',
      views: '1.2K'
    },
    {
      id: 2,
      title: 'Property Valuation Process Explained',
      description: 'Step-by-step guide to our comprehensive valuation methodology.',
      duration: '4:20',
      thumbnail: '/api/placeholder/400/225',
      views: '2.1K'
    },
    {
      id: 3,
      title: 'Client Success Story: Heritage Developments',
      description: 'How we helped a major developer optimize their property portfolio.',
      duration: '3:15',
      thumbnail: '/api/placeholder/400/225',
      views: '856'
    },
    {
      id: 4,
      title: 'Market Insights: Q4 2023 Report',
      description: 'Key trends and analysis from our latest market research.',
      duration: '5:30',
      thumbnail: '/api/placeholder/400/225',
      views: '1.5K'
    }
  ]

  const resources = [
    {
      title: 'Valuation Guidelines 2024',
      type: 'PDF',
      size: '2.4 MB',
      description: 'Comprehensive guide to property valuation standards and methodologies.',
      downloadLink: '#'
    },
    {
      title: 'Market Analysis Template',
      type: 'Excel',
      size: '1.2 MB',
      description: 'Template for conducting competitive market analysis.',
      downloadLink: '#'
    },
    {
      title: 'RICS Standards Summary',
      type: 'PDF',
      size: '3.1 MB',
      description: 'Summary of key RICS valuation standards and requirements.',
      downloadLink: '#'
    },
    {
      title: 'Investment Calculator',
      type: 'Tool',
      size: 'Web App',
      description: 'Interactive tool for property investment analysis.',
      downloadLink: '#'
    }
  ]

  const categories = [
    { id: 'all', name: 'All Content', count: pressReleases.length + blogPosts.length },
    { id: 'press', name: 'Press Releases', count: pressReleases.length },
    { id: 'blog', name: 'Blog Posts', count: blogPosts.length },
    { id: 'award', name: 'Awards', count: pressReleases.filter(item => item.category === 'award').length },
    { id: 'innovation', name: 'Innovation', count: pressReleases.filter(item => item.category === 'innovation').length }
  ]

  const filteredContent = activeTab === 'all' 
    ? [...pressReleases, ...blogPosts]
    : activeTab === 'press' 
    ? pressReleases
    : activeTab === 'blog'
    ? blogPosts
    : pressReleases.filter(item => item.category === activeTab)

  return (
    <div className="font-inter relative min-h-screen overflow-hidden">
      <Hero 
        title="Media & Gallery"
        subtitle="Latest insights, news, and resources from Ofanda Africa."
        backgroundImage="/happy-friends-champagne-toast-house-social-reunion-event-success-new-years-celebration-people-cheers-alcohol-drink-with-congratulations-gathering-bonding-party-achievement.jpg"
      />
      


        <p className='font-inter relative text-4xl z-10 max-w-4xl mx-auto py-24 px-4 space-y-20 italic text-center text-ofanda-indigo animate-slideRotate'>
          Watch out for this space.
        </p>


      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className=" rounded-2xl p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-40 h-40 border-4 border-white rounded-full -translate-x-28 translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-40 h-40 border-4 border-white rounded-full translate-x-28 -translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-3xl md:text-4xl font-bold text-white mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>


      {/* Animations */}

        <style>{`
          @keyframes doodleMove {
            0% { transform: translate(0,0); }
            50% { transform: translate(-20px,-40px); }
            100% { transform: translate(0,0); }
          }

          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }

          @keyframes slideRotate {
            0% {
              opacity: 0;
              transform: translateX(-100%) rotate(-10deg) scale(0.8);
            }
            50% {
              transform: translateX(10%) rotate(2deg) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(0) rotate(0deg) scale(1);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
            }
            25% {
              transform: translateY(-10px) rotate(1deg);
            }
            75% {
              transform: translateY(-5px) rotate(-1deg);
            }
          }

          .animate-doodleMove {
            animation: doodleMove 90s linear infinite;
          }

          .animate-shimmer {
            animation: shimmer 8s linear infinite;
          }

          .animate-slideRotate {
            animation: slideRotate 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards,
                      float 4s ease-in-out infinite 1.5s;
          }
        `}</style>
    </div>
  )
}






      {/*Future Page Content */}
      {/* <div className="relative z-10">
         <section className="py-20 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">
              Press & News
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Stay updated with our latest achievements, innovations, and market insights
            </p>
          </div>

          <Carousel
            items={pressReleases.map((news) => (
              <Card3D key={news.id} className="h-full">
                <div className="h-48 bg-gray-200 rounded-lg mb-4 flex items-center justify-center">
                  <span className="text-gray-500">News Image</span>
                </div>
                <div className="flex justify-between items-start mb-3">
                  <span className="bg-ofanda-yellow bg-opacity-20 text-ofanda-yellow px-3 py-1 rounded-full text-sm font-semibold">
                    {news.source}
                  </span>
                  <span className="text-gray-500 text-sm">{news.date}</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
                  {news.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {news.excerpt}
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">{news.readTime}</span>
                  <button className="text-ofanda-yellow font-semibold hover:text-yellow-600 transition-colors">
                    Read More →
                  </button>
                </div>
              </Card3D>
            ))}
          />
        </div>
      </section>

      <section className="py-20 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">
              Latest Insights
            </h2>
            <p className="text-xl text-gray-600">
              Expert analysis and thought leadership from our team
            </p>
          </div>

             <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveTab(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeTab === category.id
                    ? 'bg-ofanda-yellow text-gray-900'
                    : ' text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredContent.map((item) => (
              <Card3D key={item.id}>
                <div className="h-48 bg-gray-200 rounded-lg mb-4 flex items-center justify-center">
                  <span className="text-gray-500">Blog Image</span>
                </div>
                
                {item.author && (
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-ofanda-yellow rounded-full flex items-center justify-center text-white font-semibold mr-3">
                      {item.author.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">{item.author}</div>
                      <div className="text-sm text-gray-500">{item.role}</div>
                    </div>
                  </div>
                )}

                <h3 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {item.excerpt}
                </p>

                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">{item.date}</span>
                  <span className="text-gray-500 text-sm">{item.readTime}</span>
                </div>

                {item.tags && (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {item.tags.map((tag, index) => (
                      <span key={index} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </Card3D>
            ))}
          </div>
        </div>
      </section>

         <section className="py-20 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">
              Video Gallery
            </h2>
            <p className="text-xl text-gray-600">
              Watch our latest presentations, tutorials, and insights
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {videos.map((video) => (
              <Card3D key={video.id}>
                <div className="relative">
                  <div className="h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                    <span className="text-gray-500">Video Thumbnail</span>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-black bg-opacity-75 text-white px-2 py-1 rounded text-sm">
                    {video.duration}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <button className="bg-ofanda-yellow text-white rounded-full w-16 h-16 flex items-center justify-center hover:bg-yellow-600 transition-colors">
                      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </button>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">
                  {video.title}
                </h3>
                <p className="text-gray-600 mb-3">
                  {video.description}
                </p>
                <div className="flex justify-between items-center text-sm text-gray-500">
                  <span>{video.views} views</span>
                  <button className="text-ofanda-yellow font-semibold hover:text-yellow-600">
                    Watch Video
                  </button>
                </div>
              </Card3D>
            ))}
          </div>
        </div>
      </section>

       
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">
              Resources & Downloads
            </h2>
            <p className="text-xl text-gray-600">
              Valuable tools and documents for your real estate needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {resources.map((resource, index) => (
              <Card3D key={index}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <span className="bg-ofanda-yellow bg-opacity-20 text-ofanda-yellow px-3 py-1 rounded-full text-sm font-semibold mr-3">
                        {resource.type}
                      </span>
                      <span className="text-gray-500 text-sm">{resource.size}</span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {resource.title}
                    </h3>
                    <p className="text-gray-600 mb-4">
                      {resource.description}
                    </p>
                  </div>
                </div>
                <button className="w-full bg-ofanda-yellow text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition-colors duration-300 flex items-center justify-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Download Resource
                </button>
              </Card3D>
            ))}
          </div>
        </div>
      </section>

       
      <section className="py-20 bg-ofanda-yellow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">
            Stay Updated
          </h2>
          <p className="text-xl text-gray-800 mb-8">
            Subscribe to our newsletter for the latest insights and updates
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-gray-900 focus:border-gray-900"
            />
            <button className="bg-gray-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors duration-300">
              Subscribe
            </button>
          </div>
        </div>
      </section>
    </div> */}

export default Media